import styled from 'styled-components'

export const PaymentSeparator = styled.div`
  height: 10px;

  background: #eaedf4;
`
